module.exports = __webpack_public_path__ + "img/20171229_172746.03b04862.jpg";